export enum TabsConstants {
  testCase = 0,
  testCaseIncoming = 1,
  scenario = 2,
  testPlan = 3,
}
